import React from 'react';

interface SuccessHeaderSvgProps {
    variant?: 'header' | 'spot';
}

const SuccessHeaderSvg: React.FunctionComponent<SuccessHeaderSvgProps> = ({
    variant = 'header',
}) => {
    const isSpot = variant === 'spot';

    return (
        <svg
            width={isSpot ? '162.3' : '402'}
            height={isSpot ? '114.68' : '201'}
            viewBox={isSpot ? '88 42 226 160' : '0 0 402 201'}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
        >
            <g clipPath="url(#clip0_7814_22506)">
                <rect width="402" height="201" fill="white" display={isSpot ? 'none' : undefined} />
                <rect
                    x="1"
                    width="402"
                    height="201"
                    fill="white"
                    fillOpacity="0.2"
                    display={isSpot ? 'none' : undefined}
                />
                <rect
                    x="1"
                    width="402"
                    height="201"
                    fill="url(#paint0_linear_7814_22506)"
                    fillOpacity="0.3"
                    display={isSpot ? 'none' : undefined}
                />
                <g filter="url(#filter0_d_7814_22506)" display={isSpot ? 'none' : undefined}>
                    <path
                        d="M269.851 148.201C269.822 148.109 269.9 148.035 269.993 148.006C270.086 147.977 270.162 148.054 270.191 148.146C271.649 152.362 274.463 154.753 279.211 154.889C279.318 154.906 279.38 154.937 279.409 155.028C279.377 155.088 279.345 155.148 279.252 155.177C274.695 156.589 272.656 159.63 272.398 164.077C272.427 164.168 272.349 164.243 272.256 164.271C272.163 164.3 272.087 164.223 272.057 164.132C270.6 159.915 267.786 157.524 263.038 157.389C262.93 157.372 262.869 157.341 262.84 157.249C262.872 157.189 262.904 157.129 262.997 157.1C267.554 155.689 269.593 152.648 269.851 148.201Z"
                        fill="white"
                    />
                    <path
                        d="M266.45 172.861C266.459 172.811 266.513 172.795 266.563 172.804C266.613 172.812 266.63 172.866 266.621 172.915C266.272 175.21 266.995 176.977 269.163 178.152C269.208 178.185 269.229 178.214 269.221 178.263C269.191 178.284 269.162 178.304 269.112 178.296C266.657 177.883 264.972 178.814 263.772 180.815C263.764 180.864 263.709 180.88 263.659 180.872C263.609 180.863 263.593 180.81 263.601 180.761C263.95 178.465 263.227 176.698 261.06 175.523C261.014 175.49 260.993 175.461 261.002 175.412C261.031 175.392 261.061 175.371 261.111 175.38C263.566 175.793 265.25 174.861 266.45 172.861Z"
                        fill="white"
                    />
                </g>
                <g filter="url(#filter1_d_7814_22506)" display={isSpot ? 'none' : undefined}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M116.867 115.797C116.758 115.782 116.75 115.842 116.68 115.955C115.734 119.733 113.707 122.085 109.996 122.566C109.942 122.559 109.88 122.612 109.872 122.672C109.918 122.739 109.91 122.799 110.018 122.813C113.662 123.665 115.429 126.158 115.857 129.997C115.849 130.057 115.895 130.124 116.004 130.139C116.058 130.146 116.12 130.093 116.136 129.973C117.082 126.196 119.109 123.843 122.82 123.362C122.874 123.369 122.937 123.317 122.945 123.257C122.898 123.189 122.906 123.129 122.798 123.115C119.154 122.263 117.387 119.77 116.96 115.931C117.022 115.878 116.976 115.811 116.867 115.797Z"
                        fill="#9D2B6B"
                    />
                </g>
                <path
                    opacity="0.4"
                    d="M389.131 326.759H-151.524L20.455 -103.187C142.336 -90.5794 324.728 98.7007 389.131 326.759Z"
                    fill="white"
                    display={isSpot ? 'none' : undefined}
                />
                <g clipPath="url(#clip1_7814_22506)">
                    <mask
                        id="mask0_7814_22506"
                        style={{ maskType: 'alpha' }}
                        maskUnits="userSpaceOnUse"
                        x="88"
                        y="62"
                        width="226"
                        height="140"
                    >
                        <path
                            d="M205.471 103.512C205.471 114.35 201.343 124.217 194.582 131.61C194.508 133.981 194.43 135.694 194.43 135.694L191.563 146.641L189.871 155.12L190.048 155.341C190.116 155.425 190.143 155.536 190.122 155.643L189.952 156.478C196.161 152.581 200.323 146.896 203.674 142.319C203.884 142.032 204.092 141.748 204.296 141.47C205.291 140.118 206.375 138.591 207.547 136.942L207.548 136.939C207.955 136.367 208.372 135.78 208.799 135.18C209.099 131.124 209.532 126.588 210.005 125.905C210.771 124.801 218.279 109.883 220.245 105.971C220.532 105.403 221.123 105.063 221.756 105.102L221.765 105.103L221.774 105.103L221.785 105.104L221.793 105.105C222.848 105.167 223.55 106.231 223.198 107.235L221.418 114.543C221.477 114.532 221.542 114.523 221.612 114.515L228.845 102.147C229.51 101.261 230.538 100.72 231.643 100.681C231.761 100.676 232.422 101.288 232.422 101.288C232.751 101.77 232.871 102.367 232.756 102.938L232.329 105.042L236.35 98.0352C236.964 97.327 237.96 97.026 238.828 97.3738C239.635 97.698 240.151 98.4479 240.197 99.2754L240.412 103.022L240.924 103.336C244.076 101.849 247.369 100.814 250.793 100.389C260.812 99.1432 280.641 101.402 289.925 105.92L272.868 150.222C295.222 157.501 311.815 177.659 314 202H194.868L194.871 201.974H180.522L180.517 202H140.659L140.675 201.974H88C88.0014 177.158 103.698 160.31 116.429 152.652C126.278 146.727 138.677 151.135 150.914 155.486C156.059 157.316 161.176 159.135 166.062 160.172L167.105 158.456C168.149 156.217 168.879 153.865 169.29 151.466C169.179 151.396 169.109 151.268 169.121 151.126L169.499 146.454C169.509 146.33 169.579 146.226 169.678 146.168C169.666 145.669 169.641 145.171 169.602 144.672C167.837 144.904 166.037 145.024 164.209 145.024C141.42 145.024 122.947 126.438 122.947 103.512C122.947 80.5855 141.42 62 164.209 62C186.997 62 205.471 80.5855 205.471 103.512Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask0_7814_22506)">
                        <path
                            d="M205.471 103.512C205.471 126.438 186.998 145.024 164.209 145.024C141.421 145.024 122.947 126.438 122.947 103.512C122.947 80.5854 141.421 61.9999 164.209 61.9999C186.998 61.9999 205.471 80.5854 205.471 103.512Z"
                            fill="white"
                        />
                        <path
                            d="M205.471 103.512C205.471 126.438 186.998 145.024 164.209 145.024C141.421 145.024 122.947 126.438 122.947 103.512C122.947 80.5854 141.421 61.9999 164.209 61.9999C186.998 61.9999 205.471 80.5854 205.471 103.512Z"
                            fill="url(#paint1_linear_7814_22506)"
                            fillOpacity="0.6"
                        />
                        <path
                            d="M314.001 202C311.815 177.659 295.223 157.5 272.869 150.222L289.926 105.92C280.642 101.402 260.812 99.1431 250.794 100.389C231.834 102.746 216.91 123.759 207.549 136.939C206.377 138.59 205.292 140.117 204.297 141.47C204.093 141.748 203.885 142.032 203.674 142.319C197.982 150.094 189.95 161.064 173.521 161.045C166.527 161.037 158.754 158.273 150.914 155.486C138.677 151.135 126.278 146.727 116.43 152.652C103.699 160.309 88.0021 177.157 88.0007 201.974H194.871C194.871 201.983 194.87 201.991 194.869 202H314.001Z"
                            fill="white"
                        />
                        <path
                            d="M314.001 202C311.815 177.659 295.223 157.5 272.869 150.222L289.926 105.92C280.642 101.402 260.812 99.1431 250.794 100.389C231.834 102.746 216.91 123.759 207.549 136.939C206.377 138.59 205.292 140.117 204.297 141.47C204.093 141.748 203.885 142.032 203.674 142.319C197.982 150.094 189.95 161.064 173.521 161.045C166.527 161.037 158.754 158.273 150.914 155.486C138.677 151.135 126.278 146.727 116.43 152.652C103.699 160.309 88.0021 177.157 88.0007 201.974H194.871C194.871 201.983 194.87 201.991 194.869 202H314.001Z"
                            fill="url(#paint2_linear_7814_22506)"
                            fillOpacity="0.6"
                        />
                        <g filter="url(#filter2_d_7814_22506)">
                            <path
                                d="M194.306 117.672C193.565 116.351 186.741 98.8356 184.956 94.2415C184.696 93.5725 184.071 93.1286 183.359 93.1054H183.317C182.128 93.0624 181.229 94.1786 181.519 95.3412L182.962 106.764L175.117 88.4582C174.465 87.3917 173.99 87.2494 172.755 87.0871C172.635 87.0706 172.514 87.0545 172.393 87.0385C172.295 87.0745 172.176 87.1051 172.034 87.1296C169.933 87.4932 170.211 89.9463 170.692 94.1861L170.696 94.2189L167.705 83.5464C166.878 82.3805 165.216 82.1586 164.109 83.139C163.665 83.5298 163.398 84.0896 163.306 84.6759C163.214 85.2715 163.203 85.8769 163.273 86.4756L163.948 92.241L163.24 90.9889C162.723 89.8131 161.811 89.6508 160.491 90.0789C159.444 90.5641 159.362 91.446 159.444 92.6782L161.65 113.326C161.65 113.326 163.576 121.647 166.832 133.014C167.445 135.157 168.044 137.231 168.597 139.139C170.454 145.548 169.924 152.414 167.105 158.455L140.66 202H180.517L191.564 146.641L194.431 135.694C194.435 135.691 195.162 119.192 194.306 117.672Z"
                                fill="url(#paint3_linear_7814_22506)"
                            />
                        </g>
                        <g filter="url(#filter3_d_7814_22506)">
                            <path
                                d="M164.577 124.874L163.066 123.948C162.302 123.484 161.657 122.852 161.169 122.1L160.416 120.934C159.744 119.901 158.773 119.099 157.63 118.645L155.813 117.923C154.687 117.476 153.466 117.35 152.274 117.556C151.398 117.708 151 118.748 151.549 119.45L154.252 122.908L155.948 127.522C156.129 128.015 156.412 128.463 156.778 128.837L169.167 141.49C169.012 140.701 168.822 139.916 168.597 139.139C168.044 137.231 167.444 135.157 166.832 133.014C165.987 130.065 165.232 127.321 164.577 124.874Z"
                                fill="#623721"
                            />
                        </g>
                        <path
                            d="M153.233 119.454C153.233 119.454 156.034 122.117 154.253 122.912L151.55 119.454H153.233Z"
                            fill="white"
                        />
                        <g filter="url(#filter4_d_7814_22506)">
                            <path
                                d="M169.484 151.521C169.272 151.521 169.105 151.339 169.122 151.126L169.5 146.453C169.517 146.25 169.696 146.099 169.899 146.12L172.332 146.364C174.452 146.576 176.536 147.07 178.525 147.828L180.467 148.567C183.862 149.858 186.91 151.889 189.376 154.502L190.049 155.34C190.117 155.425 190.144 155.536 190.122 155.643L189.093 160.728C189.032 161.026 188.659 161.124 188.462 160.894L186.831 158.994C184.415 156.175 181.274 154.025 177.731 152.77C175.285 151.902 172.701 151.478 170.11 151.521H169.484Z"
                                fill="url(#paint4_linear_7814_22506)"
                            />
                        </g>
                        <path
                            d="M175.108 152.473C177.184 152.473 178.867 150.78 178.867 148.691C178.867 146.602 177.184 144.908 175.108 144.908C173.031 144.908 171.348 146.602 171.348 148.691C171.348 150.78 173.031 152.473 175.108 152.473Z"
                            fill="url(#paint5_linear_7814_22506)"
                        />
                        <path
                            d="M178.867 148.691C178.867 150.78 177.184 152.474 175.107 152.474C174.142 152.474 173.261 152.107 172.595 151.505C173.28 152.554 174.46 153.247 175.801 153.247C177.917 153.247 179.633 151.521 179.633 149.392C179.633 148.049 178.951 146.867 177.916 146.177C178.508 146.845 178.867 147.726 178.867 148.691Z"
                            fill="#E0A961"
                        />
                        <path
                            d="M162.696 92.0208L162.475 90.8818C161.206 89.8925 160.278 90.9647 159.972 91.6245L160.34 92.8673C160.715 94.044 161.382 93.9025 162.153 93.5763C162.769 93.3154 162.772 92.4306 162.696 92.0208Z"
                            fill="white"
                        />
                        <path
                            d="M167.268 85.5469L167.092 84.0301C165.748 82.7406 164.498 83.6569 164.041 84.2763L164.374 85.9311C164.641 87.228 165.445 87.2208 166.399 87.0441C167.162 86.9027 167.297 85.987 167.268 85.5469Z"
                            fill="white"
                        />
                        <path
                            d="M174.4 89.4575L174.115 88.2621C172.584 87.2044 171.496 88.3092 171.143 88.9938L171.604 90.3005C172.072 91.5381 172.865 91.4021 173.779 91.0748C174.51 90.813 174.498 89.8875 174.4 89.4575Z"
                            fill="white"
                        />
                        <path
                            d="M184.212 95.2638L183.962 94.1357C182.937 93.4273 182.208 94.1672 181.972 94.6257L182.339 95.8284C182.653 96.6573 183.184 96.5662 183.796 96.347C184.286 96.1716 184.278 95.5518 184.212 95.2638Z"
                            fill="white"
                        />
                        <g filter="url(#filter5_d_7814_22506)">
                            <path
                                d="M210.006 125.904C210.772 124.801 218.28 109.883 220.246 105.971C220.533 105.402 221.124 105.063 221.757 105.101C221.764 105.102 221.769 105.103 221.775 105.103C221.781 105.103 221.787 105.103 221.794 105.104C222.849 105.167 223.551 106.231 223.199 107.235L221.292 115.063L228.846 102.147C229.511 101.26 230.539 100.72 231.644 100.681C231.762 100.675 232.423 101.287 232.423 101.287C232.752 101.77 232.872 102.367 232.757 102.938L232.33 105.042L236.351 98.035C236.965 97.3267 237.961 97.0258 238.829 97.3736C239.636 97.6977 240.152 98.4476 240.198 99.2751L240.413 103.022L241.566 103.727C242.595 104.358 243.142 105.551 242.948 106.749L240.71 120.632C240.71 120.632 239.045 125.563 236.813 131.722L237.249 131.564C238.047 131.273 238.771 130.807 239.369 130.2L240.293 129.257C241.116 128.418 242.171 127.858 243.322 127.651C243.588 127.603 243.867 127.552 244.147 127.501C244.187 127.494 244.228 127.486 244.269 127.479C244.553 127.427 244.837 127.376 245.106 127.327C246.256 127.117 247.443 127.232 248.541 127.663L248.586 127.682C249.375 127.991 249.543 129.036 248.893 129.582L245.673 132.276L243.217 136.258C242.956 136.684 242.605 137.049 242.193 137.327L226.918 149.806L221.82 151.07C220.306 151.447 218.701 151.117 217.452 150.172L214.004 147.564C212.314 147.005 210.136 145.653 209.825 144.78L208.386 141.844L208.383 141.829C208.38 141.833 209.125 127.179 210.006 125.904Z"
                                fill="url(#paint6_linear_7814_22506)"
                            />
                        </g>
                        <g filter="url(#filter6_d_7814_22506)">
                            <path
                                d="M228.566 153.072C227.956 154.601 227.58 155.538 227.555 155.601C227.555 155.601 227.936 154.655 228.567 153.074L232.089 173.21C231.942 173.539 222.278 194.987 208.749 197.348L208.362 141.348L208.407 141.372C208.391 141.666 208.383 141.83 208.383 141.83L208.385 141.844L209.825 144.78C210.135 145.653 212.314 147.005 214.004 147.564L217.451 150.173C218.701 151.118 220.306 151.447 221.82 151.07L226.918 149.806L229.492 147.704C229.097 149.667 228.751 151.373 228.492 152.648L228.566 153.072Z"
                                fill="url(#paint7_linear_7814_22506)"
                            />
                        </g>
                        <g filter="url(#filter7_d_7814_22506)">
                            <path
                                d="M221.271 114.578C222.161 114.315 225.214 114.6 226.512 116.123C226.711 116.355 226.77 116.676 226.694 116.973L225.981 118.44C225.914 118.694 225.613 118.794 225.411 118.628C224.638 117.988 222.227 116.482 220.374 117.113C220.067 117.217 219.788 116.909 219.931 116.619L220.692 115.076C220.807 114.832 221.017 114.651 221.271 114.578Z"
                                fill="#B4B2B1"
                            />
                        </g>
                        <g filter="url(#filter8_d_7814_22506)">
                            <path
                                d="M238.934 139.989C238.368 139.751 237.844 139.411 237.383 138.975C235.979 137.65 234.718 136.167 235.012 134.113L235.814 132.084L237.186 131.585C237.251 131.698 237.278 131.838 237.247 131.991L236.991 133.259C236.714 134.625 237.047 136.03 237.89 137.033C238.566 137.84 239.508 138.316 240.522 138.366L240.675 138.374C240.738 138.378 240.796 138.398 240.845 138.423L238.934 139.989Z"
                                fill="#B4B2B1"
                            />
                        </g>
                        <g filter="url(#filter9_d_7814_22506)">
                            <path
                                d="M203.123 197.174C219.633 201.132 232.091 173.206 232.091 173.206L238.07 184.755C239.894 188.279 244.351 189.439 247.646 187.247C250.959 185.044 255.342 185.409 258.248 188.131L259.496 189.299L277.846 201.999H205.859L203.123 197.174Z"
                                fill="#74234E"
                            />
                        </g>
                        <path
                            d="M208.749 197.348L208.643 182.052L207.408 184.572C205.448 188.57 204.007 192.804 203.122 197.171L203.127 197.175C205.061 197.638 206.94 197.663 208.749 197.348Z"
                            fill="black"
                        />
                    </g>
                </g>
                <g filter="url(#filter10_d_7814_22506)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M251.375 49.4895C251.172 49.4624 251.158 49.5639 251.029 49.7534C249.351 56.1413 245.622 60.0861 238.706 60.8164C238.605 60.8029 238.49 60.8909 238.476 60.9924C238.564 61.1074 238.55 61.2089 238.753 61.236C245.574 62.7658 248.93 67.036 249.816 73.5593C249.803 73.6608 249.891 73.7759 250.094 73.803C250.195 73.8165 250.31 73.7285 250.338 73.5255C252.016 67.1377 255.745 63.1928 262.661 62.4625C262.762 62.4761 262.877 62.3881 262.891 62.2866C262.803 62.1715 262.816 62.07 262.613 62.043C255.793 60.5131 252.436 56.243 251.55 49.7196C251.666 49.6316 251.578 49.5166 251.375 49.4895Z"
                        fill="#E867A8"
                    />
                </g>
                <g filter="url(#filter11_d_7814_22506)">
                    <path
                        d="M268.851 164.201C268.822 164.109 268.9 164.035 268.993 164.006C269.086 163.977 269.162 164.054 269.191 164.146C270.649 168.362 273.463 170.753 278.211 170.889C278.318 170.906 278.38 170.937 278.409 171.028C278.377 171.088 278.345 171.148 278.252 171.177C273.695 172.589 271.656 175.63 271.398 180.077C271.427 180.168 271.349 180.243 271.256 180.271C271.163 180.3 271.087 180.223 271.057 180.132C269.6 175.915 266.786 173.524 262.038 173.389C261.93 173.372 261.869 173.341 261.84 173.249C261.872 173.189 261.904 173.129 261.997 173.1C266.554 171.689 268.593 168.648 268.851 164.201Z"
                        fill="white"
                    />
                    <path
                        d="M265.45 188.861C265.459 188.811 265.513 188.795 265.563 188.804C265.613 188.812 265.63 188.866 265.621 188.915C265.272 191.21 265.995 192.977 268.163 194.152C268.208 194.185 268.229 194.214 268.221 194.263C268.191 194.284 268.162 194.304 268.112 194.296C265.657 193.883 263.972 194.814 262.772 196.815C262.764 196.864 262.709 196.88 262.659 196.872C262.609 196.863 262.593 196.81 262.601 196.761C262.95 194.465 262.227 192.698 260.06 191.523C260.014 191.49 259.993 191.461 260.002 191.412C260.031 191.392 260.061 191.371 260.111 191.38C262.566 191.793 264.25 190.861 265.45 188.861Z"
                        fill="white"
                    />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_d_7814_22506"
                    x="261"
                    y="148"
                    width="19.4089"
                    height="33.8738"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="0.5" dy="0.5" />
                    <feGaussianBlur stdDeviation="0.25" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_d_7814_22506"
                    x="109.872"
                    y="115.795"
                    width="14.073"
                    height="15.3447"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="0.5" dy="0.5" />
                    <feGaussianBlur stdDeviation="0.25" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter2_d_7814_22506"
                    x="140.66"
                    y="82.5206"
                    width="56.0632"
                    height="121.479"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="1" dy="1" />
                    <feGaussianBlur stdDeviation="0.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter3_d_7814_22506"
                    x="151.297"
                    y="117.46"
                    width="18.8701"
                    height="25.0298"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="0.5" dy="0.5" />
                    <feGaussianBlur stdDeviation="0.25" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter4_d_7814_22506"
                    x="169.121"
                    y="146.118"
                    width="22.0093"
                    height="15.9036"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="0.5" dy="0.5" />
                    <feGaussianBlur stdDeviation="0.25" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter5_d_7814_22506"
                    x="208.383"
                    y="97.2287"
                    width="41.9106"
                    height="54.9937"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="0.5" dy="0.5" />
                    <feGaussianBlur stdDeviation="0.25" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter6_d_7814_22506"
                    x="208.362"
                    y="141.348"
                    width="24.7273"
                    height="57.0004"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="0.5" dy="0.5" />
                    <feGaussianBlur stdDeviation="0.25" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter7_d_7814_22506"
                    x="219.892"
                    y="114.491"
                    width="7.83325"
                    height="5.21851"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="0.5" dy="0.5" />
                    <feGaussianBlur stdDeviation="0.25" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter8_d_7814_22506"
                    x="234.969"
                    y="131.585"
                    width="6.87622"
                    height="9.40466"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="0.5" dy="0.5" />
                    <feGaussianBlur stdDeviation="0.25" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter9_d_7814_22506"
                    x="203.123"
                    y="173.206"
                    width="76.7229"
                    height="30.7935"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="1" dy="1" />
                    <feGaussianBlur stdDeviation="0.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter10_d_7814_22506"
                    x="238.476"
                    y="49.4852"
                    width="25.4148"
                    height="25.3192"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="0.5" dy="0.5" />
                    <feGaussianBlur stdDeviation="0.25" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter11_d_7814_22506"
                    x="260"
                    y="164"
                    width="19.4089"
                    height="33.8738"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="0.5" dy="0.5" />
                    <feGaussianBlur stdDeviation="0.25" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_7814_22506"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_7814_22506"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_7814_22506"
                    x1="-128"
                    y1="447.927"
                    x2="563.96"
                    y2="151.327"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="0.841625" stopColor="#5C8DFF" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_7814_22506"
                    x1="-34"
                    y1="391.5"
                    x2="444.354"
                    y2="191.537"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEF8F4" />
                    <stop offset="1" stopColor="#C74289" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_7814_22506"
                    x1="-34"
                    y1="391.5"
                    x2="444.354"
                    y2="191.537"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEF8F4" />
                    <stop offset="1" stopColor="#C74289" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_7814_22506"
                    x1="132.294"
                    y1="262.116"
                    x2="171.107"
                    y2="64.3095"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.233363" stopColor="#462615" />
                    <stop offset="0.599216" stopColor="#623721" />
                    <stop offset="0.974841" stopColor="#8B4C2E" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_7814_22506"
                    x1="184.094"
                    y1="146.166"
                    x2="172.124"
                    y2="156.243"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E0A961" />
                    <stop offset="1" stopColor="#F5CB9D" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_7814_22506"
                    x1="175.108"
                    y1="144.908"
                    x2="175.108"
                    y2="152.473"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#F5CB9D" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_7814_22506"
                    x1="215.489"
                    y1="109.72"
                    x2="232.535"
                    y2="154.184"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.135969" stopColor="#C7753D" />
                    <stop offset="0.407162" stopColor="#B4602B" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_7814_22506"
                    x1="303.998"
                    y1="231.823"
                    x2="281.611"
                    y2="138.021"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.248608" stopColor="#6A3B22" />
                    <stop offset="0.932292" stopColor="#89471E" />
                </linearGradient>
                <clipPath id="clip0_7814_22506">
                    <rect width="402" height={isSpot ? '202' : '201'} fill="white" />
                </clipPath>
                <clipPath id="clip1_7814_22506">
                    <rect width="226" height="140" fill="white" transform="translate(88 62)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default SuccessHeaderSvg;
